/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

// AddComponent: a simple button to trigger link selection
const AddLinkButton = ({ setOpen }) => (
    <button
        type="button"
        className="news-highlights-add-link-button"
        onClick={() => setOpen(true)}
    >
        Select Link
    </button>
);

export { AddLinkButton };

